const locale = {
	// #region Work Reports fields
	DETAILS_WORKREPORTS_FIELD_TITLE: 'Titolo',
	DETAILS_WORKREPORTS_FIELD_STATUS: 'Stato Rapportino',
	DETAILS_WORKREPORTS_FIELD_TYPE: 'Tipo Rapportino',
	DETAILS_WORKREPORTS_FIELD_COMPANY: 'Azienda',
	DETAILS_WORKREPORTS_FIELD_ASSIGNED_USER: 'Utente assegnato',
	DETAILS_WORKREPORTS_FIELD_DATE: 'Data',
	DETAILS_WORKREPORTS_FIELD_HOUR_FROM: 'Ora inizio',
	DETAILS_WORKREPORTS_FIELD_HOUR_TO: 'Ora fine',
	DETAILS_WORKREPORTS_FIELD_LENGTH_HOURS: 'Totale ore',
	DETAILS_WORKREPORTS_FIELD_LENGTH_MINUTES: 'Totale minuti',
	DETAILS_WORKREPORTS_FIELD_TAGS: 'Tag',
	DETAILS_WORKREPORTS_FIELD_WARNING: 'Warning',
	DETAILS_WORKREPORTS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_WORKREPORTS_FIELD_EXPENSES: 'Spese',
	DETAILS_WORKREPORTS_FIELD_KM: 'Distanza percorsa',
	DETAILS_WORKREPORTS_FIELD_LENGTH_HOURS_EXPECTED: 'Totale ore previste',
	DETAILS_WORKREPORTS_FIELD_LENGTH_MINUTES_EXPECTED: 'Totale minuti previsti',
	// DETAILS_WORKREPORTS_FIELD_PEOP: 'Referente esterno',
	DETAILS_WORKREPORTS_FIELD_CREATED_BY: 'Creato da' // ORDER_BY
	// #endregion
};

export default locale;
